import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BackpackIcon(props: IconProps) {
    return <Icon {...props} iconKey={"backpack"}/>
}
